export const setPlaces = ({ pageNumber, pageSize, places }) => state => {
  return {
    ...state,
    places: {
      ...state.places,
      items: places || [],
      lastFetch: {
        failed: false,
        reason: { message: "" },
      },
      loadingPlaces: false,
      pagination: {
        ...state.places.pagination,
        currentPageNumber: pageNumber,
        currentPageSize: pageSize,
      },
    },
  };
};
